import { render, staticRenderFns } from "./OrderHistoryData.vue?vue&type=template&id=41bc8f46&scoped=true&lang=pug"
import script from "./OrderHistoryData.vue?vue&type=script&lang=js"
export * from "./OrderHistoryData.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryData.vue?vue&type=style&index=0&id=41bc8f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bc8f46",
  null
  
)

export default component.exports